<!--
	* @Description: 办公制章管理 修改
	* @Author: ZSC
	* @Date: 2023-04-18 15:51:22.290
 * @LastEditors: PF
 * @LastEditTime: 2025-05-29 09:47:09
-->
<template>
	<div>
		<el-dialog class="w1000 h630" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
			<template #header>
				<div class="header-left">
					<el-icon class="header-icon"><Edit /></el-icon>
					<span class="header-title">修改</span>
				</div>
				<div class="header-right">
					<el-button type="info" text @click="closeWindow('openEdit', emits, false)">
						<el-icon><Close /></el-icon>
					</el-button>
				</div>
			</template>
			<el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
				<el-card class="box-card" shadow="never">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="公章编号" prop="gzbh" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-input v-model="ruleForm.gzbh" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="制章名称" prop="zzmc" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-input v-model="ruleForm.zzmc" />
              </el-form-item>
            </el-col>
            <el-col :span="6" class="upload_portrait">
              <el-upload class="user_photo" :auto-upload="true" :show-file-list="false" upFolder="cyrcglCpgl" action="#" :http-request="importClick">
                <tupian :img="ruleForm.yzty" />
              </el-upload>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="保管单位名称" prop="bgdwmc" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-input v-model="ruleForm.bgdwmc" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="保管人" >
                <el-button class="mr10" type="primary" @click="openShenQinDanTiao=true">选择</el-button>
                <el-tag class="mr10 mt10" v-if="ruleForm.bgrid" closable @close="CourseShenQinClose">{{ruleForm.bgrxm}}</el-tag>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="批准人" >
                <el-button class="mr10" type="primary" @click="openPinZhunDanTiao=true">选择</el-button>
                <el-tag class="mr10 mt10" v-if="ruleForm.pzrid" closable @close="CoursePinZhunClose">{{ruleForm.pzrxm}}</el-tag>
              </el-form-item>
            </el-col>
             <el-col :span="8">
              <el-form-item label="批准单位" prop="pzdw">
                <el-input v-model="ruleForm.pzdw" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="批准文号" prop="pzwh">
                <el-input v-model="ruleForm.pzwh" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="批准日期" prop="pzrq">
                <el-date-picker v-model="ruleForm.pzrq" type="date" value-format="YYYY-MM-DD" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="生效日期" prop="sxrq">
                <el-date-picker v-model="ruleForm.sxrq" type="date" value-format="YYYY-MM-DD" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="作废批准文号" prop="zfpzwh">
                <el-input v-model="ruleForm.zfpzwh" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="作废日期" prop="zfrq">
                <el-date-picker v-model="ruleForm.zfrq" type="date" value-format="YYYY-MM-DD" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="执行人" >
                <el-button class="mr10" type="primary" @click="openZhiXingDanTiao=true">选择</el-button>
                <el-tag class="mr10 mt10" v-if="ruleForm.zfpzrid" closable @close="CourseZhiXingClose">{{ruleForm.zfpzrxm}}</el-tag>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
			</el-form>
			<template #footer>
				<div class="dialog-footer">
					<div></div>
					<div class="footer_but">
						<el-button type="primary" @click="submit()">保存</el-button>
						<el-button type="info" @click="closeWindow('openEdit', emits, false)">关闭</el-button>
					</div>
				</div>
			</template>
		</el-dialog>
	</div>
  <jiaozhigongdantiao v-if="openPinZhunDanTiao" v-model:openDanTiao="openPinZhunDanTiao" :row="row" @ReturnData="ReturnPinZhuData"/>
  <jiaozhigongdantiao v-if="openShenQinDanTiao" v-model:openDanTiao="openShenQinDanTiao" :row="row" @ReturnData="ReturnShenQinData"/>
  <jiaozhigongdantiao v-if="openZhiXingDanTiao" v-model:openDanTiao="openZhiXingDanTiao" :row="row" @ReturnData="ReturnZhiXingData"/>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import { uploadV2 } from '@/api/publicApi'
import { submitEditForm, closeWindow, loadData } from '@/api/common.js'
import jiaozhigongdantiao from '@/components/chazhaodaihui/jiaozhigongdantiao.vue'
import tupian from "@/components/tupian.vue";

const props = defineProps({ openEdit: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openEdit', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({})
const openPinZhunDanTiao = ref(false)
const ReturnPinZhuData = (data) => {
  ruleForm.value.pzrid = data.id
  ruleForm.value.pzrxm = data.xm
}
const CoursePinZhunClose = () => {
  ruleForm.value.pzrid = ''
  ruleForm.value.pzrxm = ''
}
const openShenQinDanTiao = ref(false)
const ReturnShenQinData = (data) => {
  ruleForm.value.bgrid = data.id
  ruleForm.value.bgrxm = data.xm
}
const CourseShenQinClose = () => {
  ruleForm.value.bgrid = ''
  ruleForm.value.bgrxm = ''
}
const openZhiXingDanTiao = ref(false)
const ReturnZhiXingData = (data) => {
  ruleForm.value.zfpzrid = data.id
  ruleForm.value.zfpzrxm = data.xm
}
const CourseZhiXingClose = () => {
  ruleForm.value.zfpzrid = ''
  ruleForm.value.zfpzrxm = ''
}
// 照片
const importClick = async (file) => {
  const formData = new FormData()
  formData.append('file', file.file)
  formData.append('fwjjmc', 'public')
  formData.append('wjjmc', 'zhizhangguanLi') // 文件地址类别 /common/cyrcglCpgl/202210/18/1.jpg
  uploadV2(formData).then((res) => {
    ruleForm.value.yzty = res.data.lj + res.data.mc
  })
}
watch(
  () => props.openEdit,
  () => {
    if (props.openEdit) {
      loadData({
        url: '/api/v2/bangong/bangongzhizhangguanli/' + props.row.id,
        ruleForm,
        loadSuccess: function (res) {

        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  submitEditForm({
    url: '/api/v2/bangong/bangongzhizhangguanli',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openEdit', emits, true)
    }
  })
}
</script>
<style lang="less" scoped>
  @import '@/assets/css/tanchuang.less';
@import '@/assets/css/tanchuangbuju.less';
 .el-card {
  width: 100%;
  height: 100%;
  margin-bottom: 20px;
}
</style>
